export default __webpack_public_path__ + "static/media/mercedes-benz.6fb89663.svg";